import { ref, onMounted, onUnmounted } from 'vue'

import { getServerNowMs } from '@/shared/api/create-request'

type TimeS = number & { __tag?: 'TimeS' }

export function useTimer({
    timestamp,
    onExpire,
}: {
    timestamp: Maybe<TimeS>
    onExpire?: () => void
}) {
    const timeLeft = ref('00:00')
    let timerInterval: ReturnType<typeof setInterval>

    const calculateTimeLeft = () => {
        if (!timestamp) {
            return
        }
        const now = getServerNowMs()
        const difference = timestamp - now

        if (difference <= 0) {
            timeLeft.value = '00:00'
            clearInterval(timerInterval)
            if (typeof onExpire === 'function') {
                onExpire()
            }
            return
        }

        const totalSeconds = Math.floor(difference / 1000)
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60

        timeLeft.value =
            hours > 0
                ? [hours, minutes, seconds]
                      .map(unit => String(unit).padStart(2, '0'))
                      .join(':')
                : [minutes, seconds]
                      .map(unit => String(unit).padStart(2, '0'))
                      .join(':')
    }

    onMounted(() => {
        calculateTimeLeft()
        timerInterval = setInterval(calculateTimeLeft, 1000)
    })

    onUnmounted(() => {
        clearInterval(timerInterval)
    })

    return { timeLeft }
}
